import React, {useContext} from 'react'
import FormTranslationContext from "context/FormTranslationContext";
import NoticeTypography from "../../components/inputs/NoticeTypography";
import {Collapse} from "@material-ui/core";
import NoticeTextInput from "../../components/inputs/NoticeTextInput";
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";
import NoticeNumericInput from "../../components/inputs/NoticeNumericInput";
import GridBlock from "components/GridBlock";
import Button from "components/Button";
import ExposureNeg1Icon from "@material-ui/icons/ExposureNeg1";
import Tr from "translations/Translations";
import getObjectValue from "libs/getObjectValue";

function OrderDetailsLotCriterion(
    {
        id,
        formikProps,
        index,
        criterion,
        criteriaEvaluationStrategy,//RKT-2275
        criteriaWeightStrategy,//@CriteriaWeightStrategy
        removeCriterion
    }) {
    const gId = (name) => id + "." + name;
    const {getDict} = useContext(FormTranslationContext)
    const editable = getObjectValue('_editable', formikProps.values, true);
    const passive = getObjectValue('_passive', formikProps.values, false);
    const onlyNotice = getObjectValue('_onlyNotice', formikProps.values, false);

    const deleteAvailable = editable && criterion.type === "QUALITY" && (
        (criteriaEvaluationStrategy === "7" && index > 0) ||
        ((criteriaEvaluationStrategy === "4" || criteriaEvaluationStrategy === "5") && index > 1) ||
        (criteriaEvaluationStrategy === "6" && index > 2)
    )

    return (<>
        <GridBlock justify="space-evenly">
            <NoticeTypography formTrKey={id}>: {index + 1}</NoticeTypography>
            {(onlyNotice || passive) && <Button variant="outlined" Icon={ExposureNeg1Icon} onClick={removeCriterion}
                    disabled={!deleteAvailable}>{Tr("remove_criterion_x", {x: index + 1})}</Button>}
        </GridBlock>

        <Collapse in={criterion.type === "QUALITY"}>
            <NoticeGlossaryInput
                formikProps={formikProps}
                id={gId("qualityCriterionType")}
                items={getDict("ENUM.024")}
                required
            />
        </Collapse>

        <NoticeTextInput
            formikProps={formikProps}
            id={gId("criterionName")}
            required
        />

        <Collapse in={criteriaWeightStrategy === "1"}>
            <NoticeNumericInput
                formikProps={formikProps}
                id={gId("criterionPctgWeight")}
                required
            />
        </Collapse>
        <Collapse in={criteriaWeightStrategy === "2"}>
            <NoticeNumericInput
                formikProps={formikProps}
                id={gId("criterionPktWeight")}
                required
            />
        </Collapse>
        <Collapse in={criteriaWeightStrategy === "3"}>
            <NoticeNumericInput
                formikProps={formikProps}
                id={gId("criterionOrder")}
                required
            />
        </Collapse>
    </>)
}

OrderDetailsLotCriterion.propTypes = {};

export default OrderDetailsLotCriterion;
